import { useState } from "react";
import SideMenu from "../../components/admin/SideMenu";
import GroupProfileLists from "../../components/admin/lists/GroupProfileLists";
import GroupEdit from "../../components/admin/edit/GroupEdit";

const AdminGroups = () => {
  const [editGroupId, setEditGroupId] = useState<string | null>(null);
  const [isNew, setIsNew] = useState(false);

  const handleEditGroup = (groupId: string) => {
    setEditGroupId(groupId);
    setIsNew(false);
  };

  const handleBack = () => {
    setEditGroupId(null);
    setIsNew(false);
  };

  return (
    <div className="main-admin">
      <div className="flex">
        <SideMenu />

        <div className="main-contents">
          <h3>グループ</h3>
          {editGroupId || isNew ? (
            <GroupEdit onBack={handleBack} />
          ) : (
            <GroupProfileLists onEdit={handleEditGroup} />
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminGroups;
